import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import plików z tłumaczeniami
import en from './locales/en.json';
import pl from './locales/pl.json';

// Konfiguracja wykrywania języka
const detectionOptions = {
    // Kolejność wykrywania języka
    order: ['localStorage', 'navigator', 'htmlTag'],

    // Klucz w localStorage
    lookupLocalStorage: 'language',

    // Cache w localStorage
    caches: ['localStorage'],
};

i18n
    // Wykrywanie języka przeglądarki
    .use(LanguageDetector)
    // Integracja z React
    .use(initReactI18next)
    // Inicjalizacja
    .init({
        // Zasoby językowe
        resources: {
            en: {
                translation: en
            },
            pl: {
                translation: pl
            }
        },

        // Język domyślny
        fallbackLng: 'en',

        // Debug w development
        debug: process.env.NODE_ENV === 'development',

        // Wspierane języki
        supportedLngs: ['en', 'pl'],

        // Opcje wykrywania języka
        detection: detectionOptions,

        // Interpolacja - pozwala na używanie zmiennych w tekstach
        interpolation: {
            escapeValue: false, // React już ucieka od XSS
        },
    });

export default i18n;
